/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Gradsubs1Inputs */

const de__field_gradsubs1 = /** @type {(inputs: _Field_Gradsubs1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CHANCENabschluss Fächer`)
};

/**

* @param {_Field_Gradsubs1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_gradsubs1 = /** @type {((inputs?: _Field_Gradsubs1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Gradsubs1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_gradsubs1(inputs)
});
export { _field_gradsubs1 as "_field_gradSubs" }